import React, {PropsWithChildren} from "react";
import {css} from "@emotion/react";

import {p} from "@pg-design/helpers-css";

interface IProps extends PropsWithChildren {
    currentSlide?: number;
    slideCount?: number;
    className?: string;
}

export const NavigationButton = (props: IProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {currentSlide, slideCount, ...restProps} = props;

    return (
        <button {...restProps} css={[slickArrow]} className={props.className}>
            {props.children}
        </button>
    );
};

export const arrowSize = "2";
export const arrowWrapperSize = "4.8";

const slickArrow = css`
    display: flex !important;
    width: auto;
    height: ${arrowWrapperSize}rem;
    box-sizing: content-box;
    position: absolute;
    top: unset;
    bottom: 0;
    ${p(4, 3, 0, 3)}

    &.slick-prev:hover,
    &.slick-next:hover,
    &.slick-prev:focus,
    &.slick-next:focus {
        background: none;
    }

    &.slick-disabled {
        display: none !important;
    }

    &:before {
        display: none;
    }

    &:after {
        display: none;
    }
`;
import React, {PropsWithChildren} from "react";
import {css} from "@emotion/react";

import {p} from "@pg-design/helpers-css";

interface IProps extends PropsWithChildren {
    currentSlide?: number;
    slideCount?: number;
    className?: string;
}

export const NavigationButton = (props: IProps) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const {currentSlide, slideCount, ...restProps} = props;

    return (
        <button {...restProps} css={[slickArrow]} className={props.className}>
            {props.children}
        </button>
    );
};

export const arrowSize = "2";
export const arrowWrapperSize = "4.8";

const slickArrow = css`
    display: flex !important;
    width: auto;
    height: ${arrowWrapperSize}rem;
    box-sizing: content-box;
    position: absolute;
    top: unset;
    bottom: 0;
    ${p(4, 3, 0, 3)}

    &.slick-prev:hover,
    &.slick-next:hover,
    &.slick-prev:focus,
    &.slick-next:focus {
        background: none;
    }

    &.slick-disabled {
        display: none !important;
    }

    &:before {
        display: none;
    }

    &:after {
        display: none;
    }
`;
